import { all, call, fork, put, takeEvery, takeLatest, select } from "redux-saga/effects";
import {
  INICIA_MATRICULA,
  SALVA_MATRICULA,
  ATUALIZA_MATRICULA,
  BUSCA_MATRICULA_EDICAO,
  REMOVE_MATRICULA,
  LISTA_MATRICULA,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  LISTA_ESCOLAS_MATRICULA,
  LISTA_CURSOS_POR_ESCOLA_MATRICULA,
  LISTA_SERIES_POR_CURSO_MATRICULA,
  LISTA_TURMAS_POR_SERIE_MATRICULA,
  LISTA_ALUNOS_MATRICULA,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA,
  MATRICULA_FALECIDO_SALVAR,
  MATRICULA_FALECIDO_MODAL_CLOSE,
  MATRICULA_FALECIDO_CANCELAR,
  MATRICULA_DEIXOU_SALVAR,
  MATRICULA_DEIXOU_CANCELAR
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import {
  showAuthMessage,
  salvaMatriculaSucesso,
  removeMatriculaSucesso,
  inicioMatriculaSucesso,
  buscaMatriculaEdicaoSucesso,
  listaMatriculaSucesso,
  listaEscolasMatriculaSucesso,
  listaCursosPorEscolaMatriculaSucesso,
  listaSeriesPorCursoMatriculaSucesso,
  listaTurmasPorSerieMatriculaSucesso,
  listaAlunosMatriculaSucesso
  , listaAnosLetivosPorEscolaMatriculaSucesso
} from "actions/Matricula";
import {
  OCORRENCIAS_DISCIPLINARES_MATRICULA,
  DISPENSA_COMPONENTES_MATRICULA,
  DEIXOU_FREQUENTAR_MATRICULA,
  FALECIDO_MATRICULA,
  RECLASSIFICAR_MATRICULA,
  MATRICULA_RECLASSIFICACAO_SALVAR,
  MATRICULA_RECLASSIFICACAO_MODAL_CLOSE,
  MATRICULA_RECLASSIFICACAO_CANCELAR,
  SOLICITAR_TRANSFERENCIA_MATRICULA,
  MATRICULA_TRANSFERENCIA_SALVAR,
  MATRICULA_TRANSFERENCIA_MODAL_CLOSE,
  MATRICULA_TRANSFERENCIA_CANCELAR,
  MATRICULA_TRANSFERENCIA_VISUALIZAR,
  MATRICULA_TRANSFERENCIA_MODAL_OPEN,
  MATRICULA_DISPENSA_MODAL_OPEN,
  MATRICULA_DISPENSA_SALVAR,
  MATRICULA_DISPENSA_REMOVER,
  LISTA_TIPOS_DISPENSA,
  LISTA_DISPENSAS_MATRICULA,
  LISTA_COMPONENTES_ESCOLA_DISPENSA,
  LISTA_PERIODOS_ANO_LETIVO_DISPENSA
} from 'constants/ActionTypes';
import { showSuccessMessage, listaTiposDispensaSucesso, buscaDispensaMatriculaSucesso, openDispensaModalSucesso, listaDispensasMatriculaSucesso, listaComponentesEscolaDispensaSucesso, listaPeriodosAnoLetivoDispensaSucesso } from 'actions/Matricula';
import {
  MATRICULA_OCORRENCIA_MODAL_OPEN,
  LISTA_TIPOS_OCORRENCIA_SUCESSO,
  LISTA_MATRICULA_OCORRENCIAS_SUCESSO,
  SALVA_MATRICULA_OCORRENCIA,
  REMOVE_MATRICULA_OCORRENCIA,
  SALVA_MATRICULA_OCORRENCIA_SUCESSO,
  REMOVE_MATRICULA_OCORRENCIA_SUCESSO
} from 'constants/ActionTypes';
import { SALVA_TIPO_OCORRENCIA_DISCIPLINAR, ATUALIZA_TIPO_OCORRENCIA_DISCIPLINAR } from 'constants/ActionTypes';

// Helper para extrair mensagens de inconsistência do backend
const getMensagemErro = (ret, fallback) => {
  const status = ret && ret.response && ret.response.status;
  const data = ret && ret.response && ret.response.data;

  if (status === 400 || status === 406) {
    const inconsistencias = (data && data.inconsistencias) || [];
    if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      return inconsistencias[0].mensagem || JSON.stringify(data);
    }
    return (data && (data.mensagem || data.message)) ? (data.mensagem || data.message) : JSON.stringify(data);
  }

  if (ret && ret.message) return JSON.stringify(ret.message);
  return fallback || 'Falha na operação.';
};

const getMatriculas = async () =>
  await requisicaoApi.get('/matriculas/paginado', { params: normalizeFiltro({}) })
    .then(resposta => resposta)
    .catch(error => error);

const getMatriculaEdicao = async (id) =>
  await requisicaoApi.get('/matriculas/' + id)
    .then(resposta => resposta)
    .catch(error => error);

const normalizeFiltro = (f) => {
  const out = { ...f };
  const toParam = (v) => {
    if (v === undefined || v === null) return undefined;
    const n = Number(v);
    if (isFinite(n)) return n === 0 ? undefined : n;
    return v;
  };
  out.EscolaId = toParam(out.EscolaId);
  out.CursoId = toParam(out.CursoId);
  out.SerieId = toParam(out.SerieId);
  out.TurmaId = toParam(out.TurmaId);
  out.AlunoId = toParam(out.AlunoId);
  out.Ano = out.Ano || undefined;
  out.Texto = out.Texto || undefined;

  // Parâmetros de paginação e ordenação para o servidor
  out.page = f.page || 1;
  out.per_page = f.perPage || 10;
  out.sort = f.orderBy || undefined;
  out.direction = f.orderDirection || undefined;

  return out;
};

const getListaMatricula = async (filtros) =>
  await requisicaoApi.get('/matriculas/paginado', { params: normalizeFiltro(filtros || {}) })
    .then(resposta => resposta)
    .catch(error => error);

const normalizeRelId = (v) => {
  if (v === undefined || v === null) return null;
  const n = Number(v);
  return (isFinite(n) && n === 0) ? null : v;
};

const normalizeMatriculaPayload = (p) => {
  const base = { ...p };
  delete base.situacao;
  delete base.code;
  base.alunoId = normalizeRelId(base.alunoId);
  base.escolaId = normalizeRelId(base.escolaId);
  base.cursoId = normalizeRelId(base.cursoId);
  base.serieId = normalizeRelId(base.serieId);
  base.turmaId = normalizeRelId(base.turmaId);
  return base;
};

const adicionaMatriculaRequest = async (matricula) => {
  const payload = normalizeMatriculaPayload(matricula);
  return await requisicaoApi.post('/matriculas', payload)
    .then(resposta => resposta)
    .catch(error => error);
};

const atualizaMatriculaRequest = async (matricula) => {
  const payload = normalizeMatriculaPayload(matricula);
  return await requisicaoApi.put('/matriculas/' + (matricula.id || matricula.Id || ''), payload)
    .then(resposta => resposta)
    .catch(error => error);
}

const deleteMatriculaRequest = async (id) =>
  await requisicaoApi.delete('/matriculas/' + id)
    .then(resposta => resposta)
    .catch(error => error);

const getEscolas = async () =>
  await requisicaoApi.get('/escolas')
    .then(resposta => resposta)
    .catch(error => error);

const getCursosDaEscola = async (idEscola) =>
  await requisicaoApi.get(`/escolas/${idEscola}/cursos`)
    .then(resposta => resposta)
    .catch(error => error);
const getAnosLetivosPorEscola = async (idEscola) =>
  await requisicaoApi.get(`/escolas/${idEscola}/anos-letivos`)
    .then(resposta => resposta)
    .catch(error => error);
const getTodosCursos = async () =>
  await requisicaoApi.get('/cursos')
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
  await requisicaoApi.get('/series', { params: { CursoId: cursoId } })
    .then(resposta => resposta)
    .catch(error => error);
const getSeriesAll = async () =>
  await requisicaoApi.get('/series')
    .then(resposta => resposta)
    .catch(error => error);

const getTurmasPorSerieOuCurso = async ({ serieId, cursoId, escolaId, ano }) =>
  await requisicaoApi.get('/turmas', { params: { SerieId: serieId, SeriesId: serieId, CursoId: cursoId, EscolaId: escolaId, Ano: ano } })
    .then(resposta => resposta)
    .catch(error => error);
const getTurmasAll = async () =>
  await requisicaoApi.get('/turmas')
    .then(resposta => resposta)
    .catch(error => error);

const getAlunos = async (filtro) => {
  const params = { ...filtro };
  let url = '/alunos';

  if (params.notCursando) {
    url = '/alunos/nao-matriculados';
    delete params.notCursando;
  }

  return await requisicaoApi.get(url, { params: params || {} })
    .then(resposta => resposta)
    .catch(error => error);
};

const salvarFalecimentoRequest = async (dados) => {
  const matriculaId = dados?.matriculaId || dados?.MatriculaId || dados?.idMatricula || 0;
  const payload = {
    DataFalecimento: dados?.data_cancel || dados?.DataFalecimento || '',
    Observacao: dados?.observacao || dados?.Observacao || ''
  };
  return await requisicaoApi.post(`/matriculas/${matriculaId}/falecimento`, payload)
    .then(resposta => resposta)
    .catch(error => error);
};

const salvarDeixouRequest = async (dados) => {
  const matriculaId = dados?.matriculaId || dados?.MatriculaId || dados?.idMatricula || 0;
  const rawDate = String(dados?.data_cancel || '').trim();
  let dataIso = rawDate;
  const m = rawDate.match(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/);
  if (m) dataIso = `${m[3]}-${m[2]}-${m[1]}`;
  else if (rawDate.length >= 10) dataIso = rawDate.substring(0, 10);

  const motivoIdRaw = (dados?.id_tipo_abandono && dados.id_tipo_abandono.id != null) ? dados.id_tipo_abandono.id : dados?.id_tipo_abandono;

  const payload = {
    dataDeixouFrequentar: dataIso || '',
    tipoAbandonoId: motivoIdRaw || null,
    idadeObrigatoria: !!(dados?.deixou_de_frequentar_idade_obrigatoria),
    observacao: dados?.observacao || ''
  };
  return await requisicaoApi.post(`/matriculas/${matriculaId}/deixou-frequentar`, payload)
    .then(resposta => resposta)
    .catch(error => error);
};

const buscarFalecimentosMatriculaRequest = async (matriculaId) =>
  await requisicaoApi.get('/falecimentos-matricula', { params: { MatriculaId: matriculaId } })
    .then(resposta => resposta)
    .catch(error => error);

const cancelarFalecimentoRequest = async (falecimentoId) =>
  await requisicaoApi.delete(`/falecimentos-matricula/${falecimentoId}`)
    .then(resposta => resposta)
    .catch(error => error);

const cancelarDeixouRequest = async (matriculaId) =>
  await requisicaoApi.delete(`/matriculas/${matriculaId}/deixou-frequentar`)
    .then(resposta => resposta)
    .catch(error => error);

const salvarTransferenciaRequest = async (dados) => {
  // Tratamento da data
  const rawDate = String(dados?.data_cancel || '').trim();
  let dataIso = rawDate;
  const m = rawDate.match(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/);
  if (m) dataIso = `${m[3]}-${m[2]}-${m[1]}`;
  else if (rawDate.length >= 10) dataIso = rawDate.substring(0, 10);

  // Normalização dos IDs
  const toId = (v) => (v && (v.id !== undefined)) ? v.id : v;
  const idMotivo = toId(dados.id_motivo);

  const payload = {
    matriculaOrigemId: dados.matriculaOrigemId,
    escolaExterna: !!dados.escola_em_outro_municipio,
    motivoId: idMotivo || null,
    dataTransferencia: dataIso || '',
    observacao: dados.observacao || ''
  };

  if (payload.escolaExterna) {
    payload.nomeEscolaExterna = dados.escola_destino_externa || '';
    payload.estadoEscolaExterna = dados.estado_escola_destino_externa || '';
    payload.municipioEscolaExterna = dados.municipio_escola_destino_externa || '';
  } else {
    // Transferência Interna
    payload.turmaDestinoId = toId(dados.id_turma) || null;
  }

  return await requisicaoApi.post('/transferencias-matricula/realizar', payload)
    .then(resposta => resposta)
    .catch(error => error);
};

const cancelarTransferenciaRequest = async (matriculaId) =>
  await requisicaoApi.delete(`/matriculas/${matriculaId}/transferencia`)
    .then(resposta => resposta)
    .catch(error => error);

function* fnIniciaMatricula() {
  try {
    const retorno = yield call(getMatriculas);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      yield put(inicioMatriculaSucesso(data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaMatricula({ payload }) {
  try {
    const retorno = yield call(getListaMatricula, payload || {});
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      yield put(listaMatriculaSucesso(data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnBuscaMatriculaEdicao({ payload }) {
  try {
    const retorno = yield call(getMatriculaEdicao, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(buscaMatriculaEdicaoSucesso(retorno.data));
      try {
        const base = retorno && retorno.data ? (retorno.data.matricula || retorno.data) : {};
        const escolaId = base.escolaId || base.EscolaId || base.escola_id || 0;
        const cursoId = base.cursoId || base.CursoId || base.curso_id || 0;
        const serieId = base.serieId || base.SerieId || base.serie_id || 0;
        if (escolaId) {
          yield put({ type: LISTA_CURSOS_POR_ESCOLA_MATRICULA, payload: escolaId });
          yield put({ type: LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA, payload: escolaId });
        }
        if (cursoId) {
          yield put({ type: LISTA_SERIES_POR_CURSO_MATRICULA, payload: { cursoId } });
        }
        if (escolaId && cursoId && serieId) {
          yield put({ type: LISTA_TURMAS_POR_SERIE_MATRICULA, payload: { escolaId, cursoId, serieId } });
        }
      } catch (_e) { }
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnSalvaMatricula({ payload }) {
  try {
    const retorno = yield call(adicionaMatriculaRequest, payload);
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao salvar a matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(salvaMatriculaSucesso('Matrícula salva com sucesso'));
      yield put({ type: LISTA_MATRICULA, payload: {} });
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao salvar a matrícula');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnAtualizaMatricula({ payload }) {
  try {
    const retorno = yield call(atualizaMatriculaRequest, payload);
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao atualizar a matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(salvaMatriculaSucesso('Matrícula atualizada com sucesso'));
      yield put({ type: LISTA_MATRICULA, payload: {} });
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao atualizar a matrícula');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnRemoveMatricula({ payload }) {
  try {
    const retorno = yield call(deleteMatriculaRequest, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(removeMatriculaSucesso('Matrícula removida com sucesso'));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnSalvarFalecido({ payload }) {
  try {
    yield put({ type: 'matricula_falecimento_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(salvarFalecimentoRequest, payload || {});
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao registrar falecimento');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Falecimento registrado com sucesso'));
      yield put({ type: MATRICULA_FALECIDO_MODAL_CLOSE });
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        const matriculaId = payload?.matriculaId || payload?.MatriculaId || payload?.idMatricula || 0;
        if (matriculaId) {
          yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
        }
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao registrar falecimento');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_falecimento_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnCancelarFalecido({ payload }) {
  try {
    yield put({ type: 'matricula_falecimento_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const matriculaId = payload;
    const lista = yield call(buscarFalecimentosMatriculaRequest, matriculaId);
    if (lista.message) {
      const mensagem = getMensagemErro(lista, 'Erro ao consultar falecimentos da matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      const arr = Array.isArray(lista.data) ? lista.data : (Array.isArray(lista.data?.falecimentos) ? lista.data.falecimentos : []);
      const ultimo = Array.isArray(arr) && arr.length > 0 ? arr[arr.length - 1] : null;
      const idFalecimento = ultimo ? (ultimo.id || ultimo.Id) : null;
      if (!idFalecimento) {
        yield put(showAuthMessage('Nenhum falecimento para cancelar'));
      } else {
        const ret = yield call(cancelarFalecimentoRequest, idFalecimento);
        if (ret.message) {
          const mensagem = getMensagemErro(ret, 'Erro ao cancelar falecimento');
          yield put(showAuthMessage(mensagem));
        } else {
          yield put(showSuccessMessage('Falecimento cancelado com sucesso'));
          yield put({ type: LISTA_MATRICULA, payload: {} });
          try {
            if (matriculaId) {
              yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
            }
          } catch (_e) { }
        }
      }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao cancelar falecimento');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_falecimento_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnCancelarDeixou({ payload }) {
  try {
    yield put({ type: 'matricula_deixou_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(cancelarDeixouRequest, payload);
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao desfazer deixou de frequentar');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Registro de deixou de frequentar desfeito com sucesso'));
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        if (payload) yield put({ type: BUSCA_MATRICULA_EDICAO, payload });
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao desfazer deixou de frequentar');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_deixou_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnSalvarTransferencia({ payload }) {
  try {
    yield put({ type: 'matricula_transferencia_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(salvarTransferenciaRequest, payload || {});
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao registrar transferência');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Transferência registrada com sucesso'));
      yield put({ type: MATRICULA_TRANSFERENCIA_MODAL_CLOSE });
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        const matriculaId = payload?.matriculaOrigemId || payload?.matriculaId || payload?.MatriculaId || payload?.idMatricula || 0;
        if (matriculaId) {
          yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
        }
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao registrar transferência');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_transferencia_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnCancelarTransferencia({ payload }) {
  try {
    yield put({ type: 'matricula_transferencia_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const matriculaId = payload;
    const retorno = yield call(cancelarTransferenciaRequest, matriculaId);
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao cancelar transferência');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Transferência cancelada com sucesso'));
      yield put({ type: MATRICULA_TRANSFERENCIA_MODAL_CLOSE });
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        if (matriculaId) {
          yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
        }
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao cancelar transferência');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_transferencia_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaEscolas() {
  try {
    const retorno = yield call(getEscolas);
    if (!retorno.message && retorno.data) {
      yield put(listaEscolasMatriculaSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaCursosPorEscola({ payload }) {
  try {
    const all = (payload === 'ALL') || (payload && payload.all === true);
    const retorno = all ? yield call(getTodosCursos) : yield call(getCursosDaEscola, payload);
    if (!retorno.message && retorno.data) {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));
      yield put(listaCursosPorEscolaMatriculaSucesso(lista));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaAnosLetivosPorEscola({ payload }) {
  try {
    const retorno = yield call(getAnosLetivosPorEscola, payload);
    if (!retorno.message && retorno.data) {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.anosLetivos) ? data.anosLetivos : []);
      yield put(listaAnosLetivosPorEscolaMatriculaSucesso(lista));
      const len = Array.isArray(lista) ? lista.length : 0;
      if (len === 0) {
        yield put(showAuthMessage('A escola selecionada não possui nenhum ano letivo iniciado.'));
      }
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaSeriesPorCurso({ payload }) {
  try {
    const all = (payload === 'ALL') || (payload && payload.all === true);
    const cursoId = (typeof payload === 'object' && payload?.cursoId !== undefined) ? payload.cursoId : payload;
    const retorno = all ? yield call(getSeriesAll) : yield call(getSeriesPorCurso, cursoId);
    if (!retorno.message && retorno.data) {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : []);
      yield put(listaSeriesPorCursoMatriculaSucesso(lista));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaTurmasPorSerie({ payload }) {
  try {
    const all = (payload === 'ALL') || (payload && payload.all === true);
    const params = payload || {};
    const serieId = params.serieId || 0;
    const cursoId = params.cursoId || 0;
    const escolaId = params.escolaId || 0;
    const ano = params.ano || undefined;
    const retorno = all ? yield call(getTurmasAll) : yield call(getTurmasPorSerieOuCurso, { serieId, cursoId, escolaId, ano });
    if (!retorno.message && retorno.data) {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.turmas) ? data.turmas : []);
      yield put(listaTurmasPorSerieMatriculaSucesso(lista));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaAlunos({ payload }) {
  try {
    const retorno = yield call(getAlunos, payload || {});
    if (!retorno.message && retorno.data) {
      yield put(listaAlunosMatriculaSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export function* iniciaMatricula() {
  yield takeEvery(INICIA_MATRICULA, fnIniciaMatricula);
}

export function* listaMatricula() {
  yield takeEvery(LISTA_MATRICULA, fnListaMatricula);
}

export function* buscaMatriculaEdicao() {
  yield takeEvery(BUSCA_MATRICULA_EDICAO, fnBuscaMatriculaEdicao);
}

export function* salvaMatricula() {
  yield takeEvery(SALVA_MATRICULA, fnSalvaMatricula);
}

export function* atualizaMatricula() {
  yield takeLatest(ATUALIZA_MATRICULA, fnAtualizaMatricula);
}

export function* removeMatricula() {
  yield takeEvery(REMOVE_MATRICULA, fnRemoveMatricula);
}

export function* listaEscolasMatricula() {
  yield takeEvery(LISTA_ESCOLAS_MATRICULA, fnListaEscolas);
}

export function* listaCursosPorEscolaMatricula() {
  yield takeEvery(LISTA_CURSOS_POR_ESCOLA_MATRICULA, fnListaCursosPorEscola);
}

export function* listaAnosLetivosPorEscolaMatriculaSaga() {
  yield takeEvery(LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA, fnListaAnosLetivosPorEscola);
}

export function* listaSeriesPorCursoMatricula() {
  yield takeEvery(LISTA_SERIES_POR_CURSO_MATRICULA, fnListaSeriesPorCurso);
}

export function* listaTurmasPorSerieMatricula() {
  yield takeEvery(LISTA_TURMAS_POR_SERIE_MATRICULA, fnListaTurmasPorSerie);
}

export function* listaAlunosMatriculaSaga() {
  yield takeEvery(LISTA_ALUNOS_MATRICULA, fnListaAlunos);
}

function* fnOcorrenciasDisciplinares({ payload }) {
  try {
    yield put({ type: MATRICULA_OCORRENCIA_MODAL_OPEN, payload });
    try {
      const retornoTipos = yield call(() => requisicaoApi.get('/tipos-ocorrencia-disciplinar', { params: { search: '' } }));
      const listaTipos = Array.isArray(retornoTipos && retornoTipos.data)
        ? retornoTipos.data
        : (Array.isArray(retornoTipos?.data?.items) ? retornoTipos.data.items : []);
      yield put({ type: LISTA_TIPOS_OCORRENCIA_SUCESSO, payload: listaTipos });
    } catch (e) { }
    try {
      const retornoOc = yield call(() => requisicaoApi.get(`/matriculas/${payload}/ocorrencias-disciplinares`));
      const listaOc = Array.isArray(retornoOc && retornoOc.data) ? retornoOc.data : [];
      yield put({ type: LISTA_MATRICULA_OCORRENCIAS_SUCESSO, payload: listaOc });
    } catch (e) { }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnDispensaComponentes({ payload }) {
  try {
    yield put(showSuccessMessage(`Dispensa de componentes curriculares para matrícula ${payload}`));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnDeixouFrequentar({ payload }) {
  try {
    yield put(showSuccessMessage(`Deixou de frequentar para matrícula ${payload}`));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnSalvarDeixou({ payload }) {
  try {
    yield put({ type: 'matricula_deixou_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(salvarDeixouRequest, payload || {});
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao registrar deixou de frequentar');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Registro de deixou de frequentar realizado com sucesso'));
      yield put({ type: 'matricula_deixou_modal_close' });
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        const matriculaId = payload?.matriculaId || payload?.MatriculaId || payload?.idMatricula || 0;
        if (matriculaId) {
          yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
        }
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao registrar deixou de frequentar');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_deixou_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnFalecido({ payload }) {
  try {
    yield put(showSuccessMessage(`Falecido para matrícula ${payload}`));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnReclassificar({ payload }) {
  try {
    yield put(showSuccessMessage(`Reclassificar matrícula ${payload}`));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

const salvarReclassificacaoRequest = async (dados) => {
  const matriculaId = dados?.matriculaId || dados?.MatriculaId || dados?.idMatricula || 0;
  const rawDate = String(dados?.data_cancel || '').trim();
  let dataIso = rawDate;
  const m = rawDate.match(/^([0-9]{2})\/(\d{2})\/(\d{4})$/);
  if (m) dataIso = `${m[3]}-${m[2]}-${m[1]}`;
  else if (rawDate.length >= 10) dataIso = rawDate.substring(0, 10);

  const cursoIdRaw = (dados?.id_curso && dados.id_curso.id != null) ? dados.id_curso.id : dados?.id_curso;
  const serieIdRaw = (dados?.id_serie && dados.id_serie.id != null) ? dados.id_serie.id : dados?.id_serie;
  const turmaIdRaw = (dados?.id_turma && dados.id_turma.id != null) ? dados.id_turma.id : dados?.id_turma;

  const payload = {
    cursoId: cursoIdRaw || null,
    serieId: serieIdRaw || null,
    turmaId: turmaIdRaw || null,
    dataReclassificacao: dataIso || '',
    descricao: dados?.descricao_reclassificacao || ''
  };
  return await requisicaoApi.post(`/matriculas/${matriculaId}/reclassificacao`, payload)
    .then(resposta => resposta)
    .catch(error => error);
};

function* fnSalvarReclassificacao({ payload }) {
  try {
    yield put({ type: 'matricula_reclassificacao_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(salvarReclassificacaoRequest, payload || {});
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao salvar reclassificação');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Reclassificação realizada com sucesso'));
      yield put({ type: MATRICULA_RECLASSIFICACAO_MODAL_CLOSE });
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        const matriculaId = payload?.matriculaId || payload?.MatriculaId || payload?.idMatricula || 0;
        if (matriculaId) {
          yield put({ type: BUSCA_MATRICULA_EDICAO, payload: matriculaId });
        }
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao salvar reclassificação');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_reclassificacao_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

const cancelarReclassificacaoRequest = async (matriculaId) =>
  await requisicaoApi.delete(`/matriculas/${matriculaId}/reclassificacao`)
    .then(resposta => resposta)
    .catch(error => error);

function* fnCancelarReclassificacao({ payload }) {
  try {
    yield put({ type: 'matricula_reclassificacao_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(cancelarReclassificacaoRequest, payload);
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao cancelar reclassificação');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Reclassificação cancelada com sucesso'));
      yield put({ type: LISTA_MATRICULA, payload: {} });
      try {
        if (payload) yield put({ type: BUSCA_MATRICULA_EDICAO, payload });
      } catch (_e) { }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao cancelar reclassificação');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_reclassificacao_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnSolicitarTransferencia({ payload }) {
  try {
    yield put(showSuccessMessage(`Transferência da matrícula ${payload}`));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export function* salvarTransferenciaSaga() {
  yield takeLatest(MATRICULA_TRANSFERENCIA_SALVAR, fnSalvarTransferencia);
}

export function* cancelarTransferenciaSaga() {
  yield takeLatest(MATRICULA_TRANSFERENCIA_CANCELAR, fnCancelarTransferencia);
}

const visualizarTransferenciaRequest = async (matriculaId) => {
  return await requisicaoApi.get(`/transferencias-matricula/por-matricula/${matriculaId}`)
    .then(resposta => resposta)
    .catch(error => error);
};

function* fnVisualizarTransferencia({ payload }) {
  try {
    yield put({ type: 'matricula_transferencia_loading_on' });
    yield put({ type: ON_SHOW_LOADER });
    const retorno = yield call(visualizarTransferenciaRequest, payload);

    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao visualizar transferência');
      yield put(showAuthMessage(mensagem));
    } else {
      const dados = retorno.data || {};

      // Mapeamento dos dados para o modal
      const rawDate = String(dados.dataTransferencia || '').trim();
      let dataFormatada = rawDate;
      const m = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) dataFormatada = `${m[3]}/${m[2]}/${m[1]}`; // ddmmyyyy para máscara

      const modalData = {
        matriculaOrigemId: dados.matriculaOrigemId,
        escola_em_outro_municipio: !!dados.escolaExterna,
        escola_destino_externa: dados.nomeEscolaExterna,
        estado_escola_destino_externa: dados.localEscolaExterna ? dados.localEscolaExterna.split(' - ')[1] || '' : '', // Tentativa de extrair UF
        municipio_escola_destino_externa: dados.localEscolaExterna ? dados.localEscolaExterna.split(' - ')[0] || '' : '', // Tentativa de extrair Cidade
        id_motivo: dados.motivoId,
        data_cancel: dataFormatada,
        observacao: dados.observacao,
        readOnly: true, // Flag para indicar modo leitura
        // Mapeamento dos campos de destino (interno)
        id_escola: dados.escolaDestinoId,
        id_curso: dados.cursoDestinoId,
        id_serie: dados.serieDestinoId,
        id_turma: dados.turmaDestinoId
      };

      yield put({ type: MATRICULA_TRANSFERENCIA_MODAL_OPEN, payload: { ...modalData, _visualizar: true } });
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao visualizar transferência');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_transferencia_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

export function* visualizarTransferenciaSaga() {
  yield takeLatest(MATRICULA_TRANSFERENCIA_VISUALIZAR, fnVisualizarTransferencia);
}

// Dispensa Curricular
function* fnAbrirDispensaModal({ payload }) {
  try {

    // Carrega tipos de dispensa
    try {
      const retornoTipos = yield call(() => requisicaoApi.get('/tipo-dispensa'));
      if (retornoTipos.message) {
        const mensagem = getMensagemErro(retornoTipos, 'Erro ao carregar tipos de dispensa');
        yield put(showAuthMessage(mensagem));
      } else {
        const listaTipos = Array.isArray(retornoTipos && retornoTipos.data) ? retornoTipos.data : [];
        yield put(listaTiposDispensaSucesso(listaTipos));
      }
    } catch (e) {
      const mensagem = getMensagemErro(e, 'Erro ao carregar tipos de dispensa');
      yield put(showAuthMessage(mensagem));
    }

    // Carrega se ja tem uma dispensa curricular para a matricula
    try {
      const retornoExiste = yield call(() => requisicaoApi.get(`/dispensa-curricular/matricula/${payload}`));
      if (!retornoExiste.message && retornoExiste.data) {
        yield put(buscaDispensaMatriculaSucesso(retornoExiste.data));
      }
    } catch (e) { }

    // Carrega dispensas existentes da matrícula
    try {
      const retornoDispensas = yield call(() => requisicaoApi.get(`/dispensa-curricular?matriculaId=${payload}`));
      if (retornoDispensas.message) {
        const mensagem = getMensagemErro(retornoDispensas, 'Erro ao carregar dispensas da matrícula');
        yield put(showAuthMessage(mensagem));
      } else {
        const listaDispensas = Array.isArray(retornoDispensas && retornoDispensas.data) ? retornoDispensas.data : [];
        yield put(listaDispensasMatriculaSucesso(listaDispensas));
      }
    } catch (e) {
      const mensagem = getMensagemErro(e, 'Erro ao carregar dispensas da matrícula');
      yield put(showAuthMessage(mensagem));
    }

    // Carrega disciplinas e períodos da matrícula
    try {
      const matriculaId = payload;

      // Carrega disciplinas da matrícula (GET /api/matriculas/{id}/disciplinas)
      try {
        const retornoComponentes = yield call(() => requisicaoApi.get(`/matriculas/${matriculaId}/disciplinas`));
        if (retornoComponentes.message) {
          const mensagem = getMensagemErro(retornoComponentes, 'Erro ao carregar disciplinas da matrícula');
          yield put(showAuthMessage(mensagem));
        } else {
          const listaComponentes = Array.isArray(retornoComponentes && retornoComponentes.data) ? retornoComponentes.data : [];
          yield put(listaComponentesEscolaDispensaSucesso(listaComponentes));
        }
      } catch (e) {
        const mensagem = getMensagemErro(e, 'Erro ao carregar disciplinas da matrícula');
        yield put(showAuthMessage(mensagem));
      }

      // Carrega períodos da matrícula (GET /api/matriculas/{id}/periodos)
      try {
        const retornoPeriodos = yield call(() => requisicaoApi.get(`/matriculas/${matriculaId}/periodos`));
        if (retornoPeriodos.message) {
          const mensagem = getMensagemErro(retornoPeriodos, 'Erro ao carregar períodos da matrícula');
          yield put(showAuthMessage(mensagem));
        } else {
          const listaPeriodos = Array.isArray(retornoPeriodos && retornoPeriodos.data) ? retornoPeriodos.data : [];
          yield put(listaPeriodosAnoLetivoDispensaSucesso(listaPeriodos));
        }
      } catch (e) {
        const mensagem = getMensagemErro(e, 'Erro ao carregar períodos da matrícula');
        yield put(showAuthMessage(mensagem));
      }
    } catch (e) {
      const mensagem = getMensagemErro(e, 'Erro ao carregar dados da matrícula');
      yield put(showAuthMessage(mensagem));
    }

    yield put(openDispensaModalSucesso());
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao abrir modal de dispensa');
    yield put(showAuthMessage(mensagem));
  }
}

function* fnSalvarDispensaCurricular({ payload }) {
  try {
    yield put({ type: 'matricula_dispensa_loading_on' });
    yield put({ type: ON_SHOW_LOADER });

    const body = {
      matriculaId: payload.matriculaId,
      tipoDispensaId: payload.tipoDispensaId,
      observacoes: payload.observacoes || '',
      idsComponentesEscola: Array.isArray(payload.idsComponentesEscola) ? payload.idsComponentesEscola : [],
      idsPeriodosAnoLetivo: Array.isArray(payload.idsPeriodosAnoLetivo) ? payload.idsPeriodosAnoLetivo : []
    };

    const retorno = payload.id && payload.id !== 0
      ? yield call(() => requisicaoApi.put(`/dispensa-curricular/${payload.id}`, body))
      : yield call(() => requisicaoApi.post('/dispensa-curricular', body));

    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao salvar dispensa curricular');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Dispensa curricular salva com sucesso'));
      yield put({ type: 'matricula_dispensa_modal_close' });

      // Recarrega dispensas da matrícula
      try {
        const retornoDispensas = yield call(() => requisicaoApi.get(`/dispensa-curricular?matriculaId=${payload.matriculaId}`));
        if (retornoDispensas.message) {
          const mensagem = getMensagemErro(retornoDispensas, 'Erro ao recarregar lista de dispensas');
          yield put(showAuthMessage(mensagem));
        } else {
          const listaDispensas = Array.isArray(retornoDispensas && retornoDispensas.data) ? retornoDispensas.data : [];
          yield put(listaDispensasMatriculaSucesso(listaDispensas));
        }
      } catch (e) {
        const mensagem = getMensagemErro(e, 'Erro ao recarregar lista de dispensas');
        yield put(showAuthMessage(mensagem));
      }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao salvar dispensa curricular');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_dispensa_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnRemoverDispensaCurricular({ payload }) {
  try {
    yield put({ type: 'matricula_dispensa_loading_on' });
    yield put({ type: ON_SHOW_LOADER });

    const id = payload;
    const retorno = yield call(() => requisicaoApi.delete(`/dispensa-curricular/${id}`));

    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao remover dispensa curricular');
      yield put(showAuthMessage(mensagem));
    } else {
      yield put(showSuccessMessage('Dispensa curricular removida com sucesso'));

      // Recarrega lista de dispensas
      try {
        const state = yield select();
        const matriculaId = state.matricula?.id || 0;
        if (matriculaId) {
          const retornoDispensas = yield call(() => requisicaoApi.get(`/dispensa-curricular?matriculaId=${matriculaId}`));
          if (retornoDispensas.message) {
            const mensagem = getMensagemErro(retornoDispensas, 'Erro ao recarregar lista de dispensas');
            yield put(showAuthMessage(mensagem));
          } else {
            const listaDispensas = Array.isArray(retornoDispensas && retornoDispensas.data) ? retornoDispensas.data : [];
            yield put(listaDispensasMatriculaSucesso(listaDispensas));
          }
        }
      } catch (e) {
        const mensagem = getMensagemErro(e, 'Erro ao recarregar lista de dispensas');
        yield put(showAuthMessage(mensagem));
      }
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao remover dispensa curricular');
    yield put(showAuthMessage(mensagem));
  } finally {
    yield put({ type: 'matricula_dispensa_loading_off' });
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnListaTiposDispensa() {
  try {
    const retorno = yield call(() => requisicaoApi.get('/tipo-dispensa'));
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao carregar tipos de dispensa');
      yield put(showAuthMessage(mensagem));
    } else {
      const lista = Array.isArray(retorno && retorno.data) ? retorno.data : [];
      yield put(listaTiposDispensaSucesso(lista));
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao carregar tipos de dispensa');
    yield put(showAuthMessage(mensagem));
  }
}

function* fnListaDispensasMatricula({ payload }) {
  try {
    const retorno = yield call(() => requisicaoApi.get(`/dispensa-curricular?matriculaId=${payload}`));
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao carregar dispensas da matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      const lista = Array.isArray(retorno && retorno.data) ? retorno.data : [];
      yield put(listaDispensasMatriculaSucesso(lista));
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao carregar dispensas da matrícula');
    yield put(showAuthMessage(mensagem));
  }
}

function* fnListaComponentesEscolaDispensa({ payload }) {
  try {
    const { matriculaId } = payload;
    const retorno = yield call(() => requisicaoApi.get(`/matriculas/${matriculaId}/disciplinas`));
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao carregar disciplinas da matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      const lista = Array.isArray(retorno && retorno.data) ? retorno.data : [];
      yield put(listaComponentesEscolaDispensaSucesso(lista));
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao carregar disciplinas da matrícula');
    yield put(showAuthMessage(mensagem));
  }
}

function* fnListaPeriodosAnoLetivoDispensa({ payload }) {
  try {
    const { matriculaId } = payload;
    const retorno = yield call(() => requisicaoApi.get(`/matriculas/${matriculaId}/periodos`));
    if (retorno.message) {
      const mensagem = getMensagemErro(retorno, 'Erro ao carregar períodos da matrícula');
      yield put(showAuthMessage(mensagem));
    } else {
      const lista = Array.isArray(retorno && retorno.data) ? retorno.data : [];
      yield put(listaPeriodosAnoLetivoDispensaSucesso(lista));
    }
  } catch (error) {
    const mensagem = getMensagemErro(error, 'Erro ao carregar períodos da matrícula');
    yield put(showAuthMessage(mensagem));
  }
}

export default function* rootSaga() {
  yield all([
    fork(iniciaMatricula),
    fork(listaMatricula),
    fork(buscaMatriculaEdicao),
    fork(salvaMatricula),
    fork(atualizaMatricula),
    fork(removeMatricula),
    fork(listaEscolasMatricula),
    fork(listaCursosPorEscolaMatricula),
    fork(listaAnosLetivosPorEscolaMatriculaSaga),
    fork(listaSeriesPorCursoMatricula),
    fork(listaTurmasPorSerieMatricula),
    fork(listaAlunosMatriculaSaga),
    fork(salvarTransferenciaSaga),
    fork(cancelarTransferenciaSaga),
    fork(visualizarTransferenciaSaga),
    takeEvery(MATRICULA_FALECIDO_SALVAR, fnSalvarFalecido),
    takeEvery(MATRICULA_FALECIDO_CANCELAR, fnCancelarFalecido),
    takeEvery(OCORRENCIAS_DISCIPLINARES_MATRICULA, fnOcorrenciasDisciplinares),
    takeEvery(MATRICULA_DISPENSA_MODAL_OPEN, fnAbrirDispensaModal),
    takeLatest(MATRICULA_DISPENSA_SALVAR, fnSalvarDispensaCurricular),
    takeEvery(MATRICULA_DISPENSA_REMOVER, fnRemoverDispensaCurricular),
    takeEvery(LISTA_TIPOS_DISPENSA, fnListaTiposDispensa),
    takeEvery(LISTA_DISPENSAS_MATRICULA, fnListaDispensasMatricula),
    takeEvery(LISTA_COMPONENTES_ESCOLA_DISPENSA, fnListaComponentesEscolaDispensa),
    takeEvery(LISTA_PERIODOS_ANO_LETIVO_DISPENSA, fnListaPeriodosAnoLetivoDispensa),
    takeEvery(DEIXOU_FREQUENTAR_MATRICULA, fnDeixouFrequentar),
    takeLatest(MATRICULA_DEIXOU_SALVAR, fnSalvarDeixou),
    takeEvery(MATRICULA_DEIXOU_CANCELAR, fnCancelarDeixou),
    takeEvery(FALECIDO_MATRICULA, fnFalecido),
    takeEvery(RECLASSIFICAR_MATRICULA, fnReclassificar),
    takeLatest(MATRICULA_RECLASSIFICACAO_SALVAR, fnSalvarReclassificacao),
    takeEvery(MATRICULA_RECLASSIFICACAO_CANCELAR, fnCancelarReclassificacao),
    takeEvery(SOLICITAR_TRANSFERENCIA_MATRICULA, fnSolicitarTransferencia),
    // Tipos de Ocorrência Disciplinar
    takeEvery(SALVA_TIPO_OCORRENCIA_DISCIPLINAR, function* ({ payload }) {
      try {
        const fixLocal = (() => { try { return localStorage.getItem('idClienteFixado'); } catch (e) { return null; } })();
        const fixState = yield select(s => s.acessoGenero && s.acessoGenero.idClienteFixado);
        const idClienteFixado = fixLocal && fixLocal !== '0' ? fixLocal : fixState;
        const idCliente = (idClienteFixado && idClienteFixado !== 0) ? parseInt(idClienteFixado, 10) : 0;
        const body = {
          IdCliente: idCliente,
          Nome: payload.nm_tipo || payload.Nome || payload.nome || '',
          Descricao: payload.descricao || payload.Descricao || '',
          MaxOcorrencias: payload.max_ocorrencias ?? payload.MaxOcorrencias ?? null
        };
        yield call(() => requisicaoApi.post('/tipos-ocorrencia-disciplinar', body));
        const listaTiposResp = yield call(() => requisicaoApi.get('/tipos-ocorrencia-disciplinar', { params: { search: '' } }));
        const listaTipos = Array.isArray(listaTiposResp && listaTiposResp.data)
          ? listaTiposResp.data
          : (Array.isArray(listaTiposResp?.data?.items) ? listaTiposResp.data.items : []);
        yield put({ type: LISTA_TIPOS_OCORRENCIA_SUCESSO, payload: listaTipos });
        yield put(showSuccessMessage('Tipo de ocorrência criado com sucesso'));
      } catch (error) {
        const mensagem = getMensagemErro(error, 'Erro ao criar tipo de ocorrência');
        yield put(showAuthMessage(mensagem));
      }
    }),
    takeEvery(ATUALIZA_TIPO_OCORRENCIA_DISCIPLINAR, function* ({ payload }) {
      try {
        const fixLocal = (() => { try { return localStorage.getItem('idClienteFixado'); } catch (e) { return null; } })();
        const fixState = yield select(s => s.acessoGenero && s.acessoGenero.idClienteFixado);
        const idClienteFixado = fixLocal && fixLocal !== '0' ? fixLocal : fixState;
        const idCliente = (idClienteFixado && idClienteFixado !== 0) ? parseInt(idClienteFixado, 10) : 0;
        const id = payload.id || payload.Id || 0;
        const body = {
          Id: id,
          IdCliente: idCliente,
          Nome: payload.nm_tipo || payload.Nome || payload.nome || '',
          Descricao: payload.descricao || payload.Descricao || '',
          MaxOcorrencias: payload.max_ocorrencias ?? payload.MaxOcorrencias ?? null
        };
        yield call(() => requisicaoApi.put(`/tipos-ocorrencia-disciplinar/${id}`, body));
        const listaTiposResp = yield call(() => requisicaoApi.get('/tipos-ocorrencia-disciplinar', { params: { search: '' } }));
        const listaTipos = Array.isArray(listaTiposResp && listaTiposResp.data)
          ? listaTiposResp.data
          : (Array.isArray(listaTiposResp?.data?.items) ? listaTiposResp.data.items : []);
        yield put({ type: LISTA_TIPOS_OCORRENCIA_SUCESSO, payload: listaTipos });
        yield put(showSuccessMessage('Tipo de ocorrência atualizado com sucesso'));
      } catch (error) {
        const mensagem = getMensagemErro(error, 'Erro ao atualizar tipo de ocorrência');
        yield put(showAuthMessage(mensagem));
      }
    }),
    takeLatest(SALVA_MATRICULA_OCORRENCIA, function* ({ payload }) {
      try {
        yield put({ type: ON_SHOW_LOADER });
        const matriculaId = payload?.matriculaId || payload?.MatriculaId || payload?.idMatricula || 0;
        const ocorrenciaId = payload?.id || payload?.Id || 0;
        const tipoId = payload?.id_tipo_ocorrencia_disciplinar;
        const rawTipoNome = String(payload?.tipoNome || '').trim();
        const rawDate = String(payload?.data_ocorrencia || '').trim();
        let dataIso = rawDate;
        const m = rawDate.match(/^([0-9]{2})\/(\d{2})\/(\d{4})$/);
        if (m) dataIso = `${m[3]}-${m[2]}-${m[1]}`;
        else if (rawDate.length >= 10) dataIso = rawDate.substring(0, 10);
        let tipoIdFinal = (tipoId && tipoId.id) ? tipoId.id : tipoId;
        if ((!tipoIdFinal || tipoIdFinal === 0) && rawTipoNome) {
          const fixLocal = (() => { try { return localStorage.getItem('idClienteFixado'); } catch (e) { return null; } })();
          const fixState = yield select(s => s.acessoGenero && s.acessoGenero.idClienteFixado);
          const idClienteFixado = fixLocal && fixLocal !== '0' ? fixLocal : fixState;
          const idCliente = (idClienteFixado && idClienteFixado !== 0) ? parseInt(idClienteFixado, 10) : 0;
          const novoTipoBody = { IdCliente: idCliente, Nome: rawTipoNome, Descricao: '', MaxOcorrencias: null };
          const respTipo = yield call(() => requisicaoApi.post('/tipos-ocorrencia-disciplinar', novoTipoBody));
          const dTipo = respTipo && respTipo.data ? respTipo.data : null;
          const novoId = dTipo && (dTipo.id || dTipo.Id);
          if (novoId) tipoIdFinal = novoId;
        }
        const body = { tipoOcorrenciaDisciplinarId: tipoIdFinal, dataOcorrencia: dataIso };
        const resp = ocorrenciaId && ocorrenciaId !== 0
          ? yield call(() => requisicaoApi.put(`/ocorrencias-disciplinares/${ocorrenciaId}`, body))
          : yield call(() => requisicaoApi.post(`/matriculas/${matriculaId}/ocorrencias-disciplinares`, body));
        const d = resp && resp.data ? resp.data : payload;
        const item = {
          id: d.id || ocorrenciaId || payload.id,
          id_tipo_ocorrencia_disciplinar: body.tipoOcorrenciaDisciplinarId ?? null,
          tipoNome: rawTipoNome || d.tipoNome || '',
          data_ocorrencia: rawDate,
          matriculaId
        };
        yield put({ type: SALVA_MATRICULA_OCORRENCIA_SUCESSO, payload: item });
        try {
          const retornoOc = yield call(() => requisicaoApi.get(`/matriculas/${matriculaId}/ocorrencias-disciplinares`));
          const listaOc = Array.isArray(retornoOc && retornoOc.data) ? retornoOc.data : [];
          yield put({ type: LISTA_MATRICULA_OCORRENCIAS_SUCESSO, payload: listaOc });
        } catch (_e) { }
        yield put(showSuccessMessage('Ocorrência disciplinar salva com sucesso'));
      } catch (error) {
        const mensagem = getMensagemErro(error, 'Erro ao salvar ocorrência disciplinar');
        yield put(showAuthMessage(mensagem));
      } finally {
        yield put({ type: ON_HIDE_LOADER });
      }
    }),
    takeEvery(REMOVE_MATRICULA_OCORRENCIA, function* ({ payload }) {
      try {
        const id = payload;
        yield call(() => requisicaoApi.delete(`/ocorrencias-disciplinares/${id}`));
        yield put({ type: REMOVE_MATRICULA_OCORRENCIA_SUCESSO, payload: id });
        yield put(showSuccessMessage('Ocorrência disciplinar removida com sucesso'));
      } catch (error) {
        const mensagem = getMensagemErro(error, 'Erro ao remover ocorrência disciplinar');
        yield put(showAuthMessage(mensagem));
      }
    }),
  ]);
}
